import PropTypes from 'prop-types';
import React from 'react';
import Pill from '@99designs/react-components/components/Pill';

export default class OnsiteNotificationsIcon extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        this.props.onClick(e);
    }

    unreadCount() {
        if (this.props.unreadCount === 0) {
            return null;
        }

        return (
            <span className="top-level-nav__item__notification-counter">
                <Pill variations={['notification', 'tiny']}>
                    {this.props.unreadCount > 99 ? '99+' : this.props.unreadCount}
                </Pill>
            </span>
        );
    }

    render() {
        return (
                <a
                    href={this.props.urls.notifications}
                    onClick={this.handleClick}
                    onMouseEnter={this.props.onMouseEnter}
                    className="top-level-nav__item__link"
                    data-onsite-notifications-toggle
                >
                    <div className="top-level-nav__item__notification-icon icon--inline">
                        { this.unreadCount() }
                    </div>
                </a>
        );
    }
}

OnsiteNotificationsIcon.propTypes = {
    urls: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    unreadCount: PropTypes.number,
};

OnsiteNotificationsIcon.defaultProps = {
    onClick() {},
    onMouseEnter() {},
    unreadCount: 0,
};



// WEBPACK FOOTER //
// ./node_modules/@99designs/globalnav/src/components/onsite-notifications-icon.jsx